import { Avatar, AvatarFallback, AvatarImage } from "ui/components/avatar";

import React from "react";
import { assetUrl, fullName, initials } from "./utils";

const AvatarDisplay = ({ user, ...props }) => {
  return (
    <Avatar {...props}>
      <AvatarImage src={assetUrl(user?.avatar)} alt={fullName(user)} />
      <AvatarFallback>{initials(user)}</AvatarFallback>
    </Avatar>
  );
};

export default AvatarDisplay;
